import TreeTable from 'primevue/treetable'
import Column from 'primevue/column'
import Checkbox from 'primevue/checkbox'
import { showNotification, calculateHeightReport } from '@/services/calculate'
import { projectAPIs, masterAPIs } from '@/services/authConstantsV1'
import { instance, errorService } from '@/services/api'
import { socketEvents, reportSummary } from '@/services/config'
import { formatCurrency } from '@/services/convert'
import _ from 'lodash'
import axios from 'axios'

const getBase64 = file =>
  new Promise(function(resolve, reject) {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
export default {
  props: ['projectData'],
  components: {
    TreeTable: TreeTable,
    Column: Column,
    Checkbox: Checkbox,
  },
  data() {
    return {
      currentLogo: undefined,
      selectSource: undefined,
      ADSGDS: undefined,
      logo:
        process.env.BASE_URL + 'resources/images/KBKG-logo-landscape-print.jpg',
      visibleNoteBox: false,
      loader: false,
      visibleNotes: null,
      previewReport: undefined,
      previewReportData: undefined,
      visibleReport: false,
      checked: false,
      bonusTreeData: [],
      bonusTreeDataAllData: [],
      bonusData: [],
      notesTreeData: [],
      loaderNotes: false,
      selectedKeys3: null,
      selectedKeysNotes: null,
      fromAssetClass: undefined,
      generateOptionData: [],
      reportAddress: undefined,
      bodyStyle: "fontWeight: 'bold'",
      visible: false,
      confirmLoading: false,
      previewVisible: false,
      previewImage: '',
      loaderBonus: false,
      headStyle: {
        'font-weight': 'bold',
        background: '#333333 !important',
        color: '#ffffff !important',
        padding: '0 10px',
      },
      form: {
        note: undefined,
        notation: undefined,
      },
      rules: {
        note: [
          { required: true, message: 'Please enter note', trigger: 'blur' },
        ],
        notation: [
          { required: true, message: 'Please enter notation', trigger: 'blur' },
        ],
      },
      formBonus: {
        bonus: undefined,
      },
      rulesBonus: {
        bonus: [
          {
            required: true,
            message: 'Please enter bonus percentage',
            trigger: 'blur',
          },
        ],
      },
      previewOption: [],
      assetClassList: [],
      toAssetClass: undefined,
      rowExpanded: false,
      loadReports: false,
      loadRefresh: false,
      checkCategoryCode: false,
      src: null,
      height: '400px',
      action: null,
      visibleColumn: false,
      visibleAddress: false,
      columnName: null,
      keyCount: 0,
      selectKeyCount: 0,
      visibleAssetClass: false,
      assetClassData: [],
      closable: true,
      selectAssetKeyCount: 0,
      selectedAssetClassId: undefined,
      assetList: [],
      isAssetClassChanged: this.projectData.isAssetClassChanged,
      selectedAssetClass: null,
      takeoff: {
        acquistion: true,
        newConstructionIndirectTakeoffs: true,
        newConstructionActualCostTakeoffs: true,
        irc481: true,
      },
      formatCurrency: formatCurrency,
      reportSummary: reportSummary,
      isArchive: this.projectData.isArchive,
      activeTab: '1',
      fromMethod: undefined,
      toMethod: undefined,
      methods: [],
      fromConvention: undefined,
      toConvention: undefined,
      conventions: [],
      events: [
        socketEvents.reportAssetClassUpdated,
        socketEvents.reportMethodUpdated,
        socketEvents.reportConventionUpdated,
      ],
    }
  },
  created() {
    // this.$root.$emit('popupUpdation', true, true, 'Loading...')
    this.getNotes()
    this.getBonus()
    this.getDepreciationDropdwons()
    this.getAssetClass()
    this.getTakeOffValidation()
    // this.reconcileReport()
    this.$socketHub.$on('message-received', this.messageReceived)
  },
  mounted() {
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
    this.$root.$off('onUpdateTakeoff')
    this.$root.$off('onCloneTakeoff')
    this.$root.$off('onDeleteTakeoff')
    this.getReportTypes()
  },
  methods: {
    preview() {
      this.loadReports = true
      this.visibleReport = false
      this.previewReport = this.previewReportData
      instance
        .get(
          projectAPIs.project.asset.report.preview(
            this.$route.params.id,
            this.previewReport,
          ),
        )
        .then(response => {
          showNotification('info', _.get(response.data, 'message', ''))
        })
        .catch(err => {
          this.loadReports = false
          errorService(err)
        })
    },

    getReportTypes() {
      this.loader = true
      instance
        .get(projectAPIs.dropdown.reportType(this.$route.params.id))
        .then(res => {
          this.loader = false
          this.previewOption = _.get(res.data, 'result', [])
          this.height = calculateHeightReport('reportTable')
        })
        .catch(err => {
          this.$root.$emit('popupUpdation', false, true, null)
          this.loader = false
          errorService(err)
        })
    },

    getNotes() {
      this.loader = true
      this.notesTreeData = []
      instance
        .get(projectAPIs.project.asset.report.notes(this.$route.params.id))
        .then(res => {
          this.loader = false
          const data = _.get(res.data, 'result', [])
          data.map((element, index) => {
            this.notesTreeData.push({
              key: element.assetId,
              data: {
                assetId: element.assetId,
                assetNumber: element.assetNumber,
                description: element.assetDescription,
              },
              children: [],
            })
            if (element.categories && element.categories.length > 0) {
              this.notesTreeData[index]['children'].push({
                key: '0##' + index,
                data: {
                  type: 'header',
                  assetNumber: 'Category Code',
                  description: 'Description',
                  notation: 'Notation',
                  note: 'Note',
                },
                children: [],
              })
              element.categories.map(category => {
                this.notesTreeData[index]['children'][0]['children'].push({
                  key:
                    element.assetId +
                    '-' +
                    category.categoryCode +
                    '-' +
                    category.id,
                  data: {
                    catId: category.id,
                    categoryCode: category.categoryCode,
                    assetId: element.assetId,
                    assetNumber: category.categoryCode,
                    description: category.categoryCodeDescription,
                    notation: category.notation,
                    note: category.notes,
                  },
                })
              })
            }
          })
        })
        .catch(err => {
          this.$root.$emit('popupUpdation', false, true, null)
          this.loader = false
          errorService(err)
        })
    },

    getAssetClass() {
      this.loader = true
      this.assetClassData = []
      this.selectAssetKeyCount = 0
      instance
        .get(projectAPIs.project.asset.report.assetClass(this.$route.params.id))
        .then(res => {
          this.loader = false
          const data = _.orderBy(
            _.get(res.data, 'result', []),
            ['assetNumber'],
            ['asc'],
          )
          data.map((element, index) => {
            this.assetClassData.push({
              key: element.assetId,
              data: {
                assetId: element.assetId,
                assetNumber: element.assetNumber,
                description: element.assetDescription,
                costBasis: element.costBasis,
                convention: element.convention,
                method: element.method,
              },
              children: [],
            })
            this.selectAssetKeyCount++
            if (element.categories && element.categories.length > 0) {
              this.assetClassData[index]['children'].push({
                key: '0##' + element.assetId,
                data: {
                  type: 'header',
                  assetNumber: 'Category Code',
                  description: 'Description',
                  life: 'Life',
                  assetClass: 'Asset Class',
                  convention: 'Convention',
                  method: 'Method',
                },
                children: [],
              })
              this.selectAssetKeyCount++
              element.categories.map((category, index2) => {
                this.assetClassData[index]['children'][0]['children'].push({
                  key:
                    element.assetId +
                    '-' +
                    category.categoryCode +
                    '-' +
                    category.categoryCodeId,
                  data: {
                    assetId: element.assetId,
                    assetNumber: category.categoryCode,
                    description: category.categoryCodeDescription,
                    life: category.life,
                    assetClass: category.assetClass,
                    assetClassId: category.assetClassId,
                    convention: category.convention,
                    method: category.method,
                  },
                })
                this.selectAssetKeyCount++
              })
            }
          })
        })
        .catch(err => {
          this.$root.$emit('popupUpdation', false, true, null)
          this.loader = false
          errorService(err)
        })
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },

    beforeUpload(file) {
      const isJpgOrPng =
        file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        showNotification('error', 'Please upload image file only')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        showNotification('error', 'Image must smaller than 2MB!')
      }
      return isJpgOrPng && isLt2M
    },

    handleChange(info) {
      const isJpgOrPng =
        info.file.type === 'image/jpeg' || info.file.type === 'image/png'
      if (isJpgOrPng) {
        getBase64(info.file.originFileObj)
          .then(result => {
            this.loadReports = true
            this.logo = result
            if (this.currentLogo !== this.logo && !this.loader) {
              this.currentLogo = this.logo
              this.updateReport({ reportLogo: this.logo }, 'Logo')
            }
          })
          .catch(e => e)
      }
    },

    uploadRequest() {
      setTimeout(() => {
        return true
      }, 0)
    },

    downloadData(data) {
      const that = this
      this.$notification.destroy()
      if (!data.isPreview) {
        this.$notification.info({
          message: 'Downloading File',
          description: function(createElement) {
            return createElement('div', [
              createElement(
                'div',
                'Please wait while your file is downloading...',
              ),
              createElement('a-progress', {
                props: {
                  percent: that.progress,
                },
                attrs: {
                  status: that.status,
                },
              }),
            ])
          },
          duration: 2,
        })
        this.downloadProgress()
      }
      this.displayPreviewReport(data)
    },

    displayPreviewReport(data) {
      this.$notification.destroy()
      instance
        .post(masterAPIs.download, data, { responseType: 'arraybuffer' })
        .then(response => {
          if (response.status === 200) {
            let blob
            if (data.isPreview) {
              blob = new Blob([response.data], { type: 'application/pdf' })
              const fileURL = URL.createObjectURL(blob)
              const fileLink = document.createElement('a')
              fileLink.href = fileURL
              this.src = `${fileLink.href}#view=fitH&toolbar=0`
              this.loadReports = false
            } else {
              blob = new Blob([response.data])
              const fileURL = URL.createObjectURL(blob)
              const fileLink = document.createElement('a')
              fileLink.href = fileURL
              fileLink.setAttribute(
                'download',
                data.downloadName + '.' + data.filename.split('.')[1],
              )
              document.body.appendChild(fileLink)
              this.handleCancel()
              fileLink.click()
              this.status = 'success'
              this.progress = 100
            }
          }
        })
        .catch(err => {
          this.loadReports = false
          errorService(err)
        })
    },

    downloadProgress() {
      const that = this
      this.intervalId = setInterval(function() {
        if (that.progress < 50) {
          that.progress = that.progress + 1
        } else if (that.progress >= 50 && that.progress < 75) {
          that.progress = that.progress + 0.5
        } else if (that.progress >= 75 && that.progress < 90) {
          that.progress = that.progress + 0.25
        } else if (that.progress >= 90 && that.progress < 95) {
          that.progress = that.progress + 0.1
        } else if (that.progress >= 95) {
          that.progress = that.progress + 0.01
        } else {
          clearInterval(that.intervalId)
        }
      }, 200)
    },

    getBonus() {
      this.loader = true
      this.bonusTreeData = []
      this.bonusTreeDataAllData = []
      this.keyCount = 0
      this.selectKeyCount = 0
      instance
        .get(projectAPIs.project.asset.report.bonus(this.$route.params.id))
        .then(res => {
          this.loader = false
          const data = _.get(res.data, 'result', [])
          data.map((element, index) => {
            this.bonusTreeData.push({
              key: element.assetId,
              data: {
                assetNumber: element.assetNumber,
                description: element.assetDescription,
                costBasis: element.costBasis,
                bonus: undefined,
              },
              children: [],
            })
            this.keyCount++
            // for all data
            this.bonusTreeDataAllData.push({
              key: element.assetId,
              data: {
                assetNumber: element.assetNumber,
                description: element.assetDescription,
                costBasis: element.costBasis,
                bonus: undefined,
              },
              children: [],
            })
            this.selectKeyCount++
            if (element.categories && element.categories.length > 0) {
              this.bonusTreeData[index]['children'].push({
                key: '0##' + element.assetId,
                data: {
                  type: 'header',
                  assetNumber: 'Category Code',
                  description: 'Description',
                  bonus: 'Bonus',
                  life: 'Life',
                  assetClass: 'Asset Class',
                },
                children: [],
              })
              this.keyCount++
              // for all data
              this.bonusTreeDataAllData[index]['children'].push({
                key: '0##' + element.assetId,
                data: {
                  type: 'header',
                  assetNumber: 'Category Code',
                  description: 'Description',
                  bonus: 'Bonus',
                  life: 'Life',
                  assetClass: 'Asset Class',
                },
                children: [],
              })
              this.selectKeyCount++
              element.categories.map((category, index2) => {
                if (category.life > 0 && category.life <= 20) {
                  this.bonusTreeData[index]['children'][0]['children'].push({
                    key:
                      element.assetId +
                      '-' +
                      category.categoryCode +
                      '-' +
                      index2 +
                      '-' +
                      category.life,
                    data: {
                      assetNumber: category.categoryCode,
                      description: category.categoryCodeDescription,
                      bonus: category.bonus,
                      life: category.life,
                      assetClass: category.assetClass,
                    },
                  })
                  this.keyCount++
                }
                // for all Data
                this.bonusTreeDataAllData[index]['children'][0][
                  'children'
                ].push({
                  key:
                    element.assetId +
                    '-' +
                    category.categoryCode +
                    '-' +
                    index2 +
                    '-' +
                    category.life,
                  data: {
                    assetNumber: category.categoryCode,
                    description: category.categoryCodeDescription,
                    bonus: category.bonus,
                    life: category.life,
                    assetClass: category.assetClass,
                  },
                })
                this.selectKeyCount++
              })
            }
          })
          this.bonusData = this.bonusTreeData
        })
        .catch(err => {
          this.$root.$emit('popupUpdation', false, true, null)
          this.loader = false
          errorService(err)
        })
    },

    // displayAll
    onChange(event) {
      this.checkCategoryCode = event.target.checked
      if (event.target.checked) {
        this.bonusData = [...this.bonusTreeDataAllData]
      } else {
        this.bonusData = [...this.bonusTreeData]
      }
      if (this.checked) {
        this.selectAll(null, null)
      } else if (
        this.selectedKeys3 &&
        Object.keys(this.selectedKeys3).length > 0
      ) {
        this.checked = Object.keys(this.selectedKeys3).every(
          i => this.selectedKeys3[i].checked,
        )
      } else {
        this.selectedKeys3 = undefined
      }
    },

    clickExpanded() {
      this.rowExpanded = !this.rowExpanded
      this.height = calculateHeightReport('reportTable', this.rowExpanded)
      const element = document.getElementById('appVersion')
      if (element) {
        element.style.display = this.rowExpanded ? 'none' : 'block'
      }
      this.$root.$emit('expanded', this.rowExpanded)
    },

    updateAddress() {
      this.loadRefresh = true
      this.updateReport({ projectDescription: this.reportAddress }, 'Address')
    },

    cancelUpdateAddress() {
      this.visibleAddress = false
      this.reportAddress = undefined
    },

    generateReport(report) {
      const reports = report ? [report] : this.generateOptionData
      instance
        .post(
          projectAPIs.project.asset.report.generate(this.$route.params.id),
          reports,
        )
        .then(res => {
          if (this.action === 'Generate') {
            showNotification('info', _.get(res.data, 'message', ''))
          }
        })
        .catch(err => {
          errorService(err)
        })
    },

    updateReport(data, type) {
      this.loadRefresh = true
      instance
        .patch(
          projectAPIs.project.asset.report.generate(this.$route.params.id),
          data,
        )
        .then(response => {
          if (type === 'Address') {
            this.visibleAddress = false
            this.loadRefresh = false
            this.reportAddress = undefined
          } else {
            this.loadReports = false
            this.currentLogo = undefined
          }
          this.loadRefresh = false
          showNotification(
            'success',
            'Report',
            _.get(response.data, 'message'),
          )
          if (this.previewReport) {
            this.preview()
          }
        })
        .catch(err => {
          this.loadRefresh = false
          this.loadReports = false
          errorService(err)
        })
    },

    onReportView(action) {
      this.action = action
      this.generateReport()
    },

    openPopup(type) {
      if (type === 'Address') {
        this.visibleAddress = !this.visibleAddress
      } else {
        this.visibleColumn = !this.visibleColumn
      }
    },

    onNodeSelect(node) {},

    onNodeUnselect(node) {
      if (!this.selectedKeysNotes.length) {
        // this.selectedKeysNotes = undefined
      }
    },

    onNodeSelectBonus(node) {
      if (this.checkCategoryCode) {
        this.checked =
          this.selectKeyCount === Object.keys(this.selectedKeys3).length
      } else {
        this.checked = this.keyCount === Object.keys(this.selectedKeys3).length
      }
    },

    onNodeUnselectBonus(node) {
      if (_.isEmpty(this.selectedKeys3)) {
        this.selectedKeys3 = undefined
      } else if (Object.keys(this.selectedKeys3).length > 0) {
        if (
          Object.keys(this.selectedKeys3).every(
            i => !this.selectedKeys3[i].checked,
          )
        ) {
          this.selectedKeys3 = undefined
        }
      }
      this.checked = false
      this.selectedAssetClass = { ...this.selectedKeys3 }
    },

    onNodeSelectAssetClass(node) {
      this.checked =
        this.selectAssetKeyCount === Object.keys(this.selectedKeys3).length
      if (node.children && node.children.length > 0) {
        let assetId = node.data.assetId
        if (!node.data.assetId) {
          const list = node.children.map(i => i.data)
          assetId = list[0].assetId
        }
        let checked = false
        if (
          this.selectedAssetClass &&
          !_.isEmpty(this.selectedAssetClass) &&
          Object.keys(this.selectedAssetClass).length > 0
        ) {
          const assetList = Object.keys(this.selectedAssetClass)
            .filter(i => Number(i.split('-')[0]) === assetId)
            .map(x => this.selectedAssetClass[x])
          checked = assetList.some(i => i.partialChecked)
        }
        if (this.selectedAssetClassId && !checked) {
          this.onSelectAssetClass(assetId)
        } else if (checked) {
          this.onUnselectAssetClass(assetId)
        }
      }
    },

    onNodeUnselectAssetClass(node) {
      if (_.isEmpty(this.selectedKeys3)) {
        this.selectedKeys3 = undefined
      } else if (Object.keys(this.selectedKeys3).length > 0) {
        if (
          Object.keys(this.selectedKeys3).every(
            i => !this.selectedKeys3[i].checked,
          )
        ) {
          this.selectedKeys3 = undefined
        }
      }
      this.checked = false
      this.selectedAssetClass = this.selectedKeys3
    },

    showModal() {
      this.visible = true
      this.formBonus.bonus = undefined
      this.checkCategoryCode = false
      this.checked = false
      this.bonusData = [...this.bonusTreeData]
      this.selectedKeys3 = undefined
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    showAssetClassModal() {
      this.activeTab = '1'
      this.visibleAssetClass = true
      this.selectedAssetClassId = undefined
      this.fromAssetClass = undefined
      this.toAssetClass = undefined
      this.selectedKeys3 = undefined
      this.checked = false
      this.fromMethod = undefined
      this.toMethod = undefined
      this.fromConvention = undefined
      this.toConvention = undefined
    },

    handleCancelAssetClass() {
      this.visibleAssetClass = false
      this.selectedAssetClassId = undefined
      this.selectedKeys3 = undefined
      this.checked = false
    },

    selectAll(event, note) {
      if (this.checked) {
        const selectedata = []
        const staticVar = note
          ? this.notesTreeData
          : this.checkCategoryCode
            ? this.bonusTreeDataAllData
            : this.bonusTreeData
        staticVar.map(data => {
          selectedata[data.key] = { checked: true, partialChecked: false }
          if (data.children) {
            data.children.map(firstLevel => {
              selectedata[firstLevel.key] = {
                checked: true,
                partialChecked: false,
              }
              if (firstLevel.children) {
                firstLevel.children.map(secondLevel => {
                  selectedata[secondLevel.key] = {
                    checked: true,
                    partialChecked: false,
                  }
                })
              }
            })
            if (note) {
              this.selectedKeysNotes = selectedata
            } else {
              this.selectedKeys3 = selectedata
            }
          }
        })
      } else {
        if (note) {
          this.selectedKeysNotes = undefined
        } else {
          this.selectedKeys3 = undefined
        }
      }
    },

    handleOk(e) {
      this.ModalText = 'The modal will be closed after two seconds'
      this.confirmLoading = true
      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000)
    },

    handleCancel(e) {
      this.visible = false
      this.selectedKeys3 = undefined
      this.checked = false
      this.checkCategoryCode = false
      this.formBonus.bonus = undefined
      this.bonusData = [...this.bonusTreeData]
    },

    handleCancelNotes(e) {
      this.visibleNotes = false
      this.selectedKeysNotes = undefined
    },

    addNote() {
      this.visibleNoteBox = true
      this.form.note = undefined
      this.form.notation = undefined
      if (this.$refs.ruleNoteForm) {
        this.$refs.ruleNoteForm.resetFields()
      }
    },

    update() {
      this.loaderNotes = true
      const req = []
      Object.keys(this.selectedKeysNotes).forEach(key => {
        const splitKey = key.split('-')
        if (splitKey.length !== 1) {
          req.push({
            id: splitKey[2] !== 'undefined' ? splitKey[2] : undefined,
            notes: this.form.note,
            notation: this.form.notation,
            reportTypeId: this.previewReport,
            categoryCode: splitKey[1],
            assetId: splitKey[0],
          })
        }
      })
      instance
        .put(projectAPIs.project.asset.report.notes(this.$route.params.id), req)
        .then(res => {
          showNotification('success', 'Notation added successfully')
          this.visibleNotes = false
          this.loaderNotes = false
          this.selectedKeysNotes = undefined
          this.form.note = undefined
          this.form.notation = undefined
          this.checked = false
          if (this.previewReport) {
            this.preview()
          }
          this.getNotes()
        })
        .catch(err => {
          errorService(err)
          this.loaderNotes = false
        })
      this.visibleNoteBox = false
    },

    deleteNote() {
      const req = []
      Object.keys(this.selectedKeysNotes).forEach(key => {
        const splitKey = key.split('-')
        if (splitKey.length === 3 && splitKey[2] !== 'undefined') {
          req.push(splitKey[2])
        }
      })
      var that = this
      this.$confirm({
        title: `Are you sure want to delete notation?`,
        content: h => (
          <div style="color:red">
            <p>This action will delete notation from respective category.</p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.loaderNotes = true
          instance
            .patch(
              projectAPIs.project.asset.report.notes(that.$route.params.id),
              req,
            )
            .then(res => {
              showNotification('success', 'Notation deleted successfully')
              that.visibleNotes = false
              that.loaderNotes = false
              that.selectedKeysNotes = undefined
              that.checked = false
              if (that.previewReportData) {
                that.preview()
              }
              that.getNotes()
            })
            .catch(err => {
              that.loaderNotes = false
              errorService(err)
            })
        },
        onCancel() {},
      })
    },

    applyBonus() {
      const req = []
      if (
        this.formBonus.bonus > '0.01' &&
        this.formBonus.bonus <= '99999999.99'
      ) {
        let updateKeys = this.selectedKeys3
        if (!this.checkCategoryCode) {
          updateKeys = Object.keys(updateKeys).filter(
            i =>
              i.split('-').length > 2 &&
              i.split('-')[3] > 0 &&
              i.split('-')[3] <= 20,
          )
        } else {
          updateKeys = Object.keys(updateKeys).filter(
            i => i.split('-').length > 2,
          )
        }
        updateKeys.forEach(key => {
          const splitKey = key.split('-')
          req.push({
            bonus: this.formBonus.bonus,
            categoryCode: splitKey[1],
            assetId: splitKey[0],
          })
        })
        if (req.length > 0) {
          this.loaderBonus = true
          instance
            .put(
              projectAPIs.project.asset.report.bonus(this.$route.params.id),
              req,
            )
            .then(res => {
              showNotification('success', 'Bonus applied successfully')
              this.visible = false
              this.loaderBonus = false
              this.selectedKeys3 = undefined
              updateKeys = undefined
              this.checked = false
              this.formBonus.bonus = undefined
              if (this.previewReport) {
                this.preview()
              }
              this.getBonus()
            })
            .catch(err => {
              errorService(err)
              this.loaderBonus = false
            })
          this.visibleNoteBox = false
        } else {
          showNotification(
            'info',
            'Apply Bonus',
            'No records found for apply bonus',
          )
        }
      } else {
        showNotification(
          'error',
          'Value should be greater than 0 and less than or equal to 100',
        )
      }
    },

    deleteBonus() {
      const req = []
      let updateKeys = this.selectedKeys3
      if (!this.checkCategoryCode) {
        updateKeys = Object.keys(updateKeys).filter(
          i =>
            i.split('-').length > 2 &&
            i.split('-')[3] > 0 &&
            i.split('-')[3] <= 20,
        )
      } else {
        updateKeys = Object.keys(updateKeys).filter(
          i => i.split('-').length > 2,
        )
      }
      updateKeys.forEach(key => {
        const splitKey = key.split('-')
        if (splitKey[2] !== 'undefined') {
          req.push({
            assetId: splitKey[0],
            categoryCode: splitKey[1],
          })
        }
      })
      if (req.length > 0) {
        var that = this
        this.$confirm({
          title: `Are you sure want to delete bonus?`,
          content: h => (
            <div style="color:red">
              <p>This action will delete bonus from respective category.</p>
              <p>Please confirm.</p>
            </div>
          ),
          onOk() {
            that.loaderBonus = true
            instance
              .put(
                projectAPIs.project.asset.report.bonus(that.$route.params.id),
                req,
              )
              .then(res => {
                showNotification('success', 'Bonus deleted successfully')
                // that.visible = false
                that.loaderBonus = false
                that.selectedKeys3 = undefined
                that.checked = false
                if (that.previewReport) {
                  that.preview()
                }
                that.getBonus()
              })
              .catch(err => {
                that.loaderBonus = false
                errorService(err)
              })
          },
          onCancel() {},
        })
      } else {
        showNotification(
          'info',
          'Delete Bonus',
          'No records found for delete bonus',
        )
      }
    },

    deleteLogo() {
      this.logo = null
      var that = this
      this.$confirm({
        title: `Are you sure want to delete logo?`,
        content: h => (
          <div style="color:red">
            <p>This action will delete logo from all reports.</p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.updateReport({ reportLogo: '' }, 'Logo')
        },
        onCancel() {},
      })
    },

    cancelUpdate() {
      this.visibleNoteBox = false
      if (this.$refs.ruleNoteForm) {
        this.$refs.ruleNoteForm.resetFields()
      }
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },

    onChangeAsset(val, key) {
      this.selectSource = this.assetClassList.find(
        data => data.assetClass === val,
      )
      if (this.selectSource) {
        this.ADSGDS = this.selectSource.gdsAds.toUpperCase()
      }
    },

    onChangeAssetClass(val) {
      const assetClass = this.assetClassList.find(
        data => data.assetClass === val,
      )
      this.checked = false
      this.selectedKeys3 = undefined
      this.selectedAssetClass = undefined
      if (assetClass) {
        this.selectedAssetClassId = assetClass.assetClassId
      } else {
        this.selectedAssetClassId = undefined
      }
    },

    onSelectAssetClass(id) {
      const selectedata = []
      const selectedKeys = this.selectedKeys3
      const assets = this.assetClassData
      if (this.selectedAssetClassId && id) {
        assets.map(data => {
          let checked = false
          let partiallyChecked = false
          if (data.children) {
            data.children.map(i => {
              if (i.children) {
                let assetId
                i.children.map(x => {
                  if (
                    this.activeTab === '1' &&
                    x.data.assetClassId === this.selectedAssetClassId &&
                    x.data.assetId === id
                  ) {
                    selectedata[x.key] = {
                      checked: true,
                      partialChecked: false,
                    }
                  } else if (
                    this.activeTab === '2' &&
                    x.data.method === this.selectedAssetClassId &&
                    x.data.assetId === id
                  ) {
                    selectedata[x.key] = {
                      checked: true,
                      partialChecked: false,
                    }
                  } else if (
                    this.activeTab === '3' &&
                    x.data.convention === this.selectedAssetClassId &&
                    x.data.assetId === id
                  ) {
                    selectedata[x.key] = {
                      checked: true,
                      partialChecked: false,
                    }
                  } else if (x.data.assetId === id) {
                    if (this.activeTab === '1') {
                      partiallyChecked = i.children.some(
                        i =>
                          i.data.assetClassId === this.selectedAssetClassId &&
                          i.data.assetId === id,
                      )
                    } else if (this.activeTab === '2') {
                      partiallyChecked = i.children.some(
                        i =>
                          i.data.method === this.selectedAssetClassId &&
                          i.data.assetId === id,
                      )
                    } else if (this.activeTab === '3') {
                      partiallyChecked = i.children.some(
                        i =>
                          i.data.convention === this.selectedAssetClassId &&
                          i.data.assetId === id,
                      )
                    }
                    selectedata[x.key] = {
                      checked: false,
                      partialChecked: false,
                    }
                    selectedKeys[x.key] = {
                      checked: false,
                      partialChecked: false,
                    }
                  }
                  assetId = x.data.assetId
                })
                if (this.activeTab === '1') {
                  checked = i.children.every(
                    i =>
                      i.data.assetClassId === this.selectedAssetClassId &&
                      i.data.assetId === id,
                  )
                } else if (this.activeTab === '2') {
                  checked = i.children.every(
                    i =>
                      i.data.method === this.selectedAssetClassId &&
                      i.data.assetId === id,
                  )
                } else if (this.activeTab === '3') {
                  checked = i.children.every(
                    i =>
                      i.data.convention === this.selectedAssetClassId &&
                      i.data.assetId === id,
                  )
                }
                if (assetId === id) {
                  selectedata[data.children[0].key] = {
                    checked: checked,
                    partialChecked: partiallyChecked,
                  }
                }
              }
            })
          }
          if (data.key === id) {
            selectedata[data.key] = {
              checked: checked,
              partialChecked: partiallyChecked,
            }
          }
        })
        this.selectedKeys3 = { ...selectedKeys, ...selectedata }
        this.selectedAssetClass = this.selectedKeys3
      }
    },

    onUnselectAssetClass(id) {
      const selectedata = []
      const selectedKeys = this.selectedKeys3
      const assets = this.assetClassData
      if (id) {
        assets.map(data => {
          if (data.children) {
            data.children.map(i => {
              if (i.children) {
                let assetId
                i.children.map(x => {
                  if (x.data.assetId === id) {
                    selectedata[x.key] = {
                      checked: false,
                      partialChecked: false,
                    }
                  }
                  assetId = x.data.assetId
                })
                if (assetId === id) {
                  selectedata[data.children[0].key] = {
                    checked: false,
                    partialChecked: false,
                  }
                }
              }
            })
          }
          if (data.key === id) {
            selectedata[data.key] = {
              checked: false,
              partialChecked: false,
            }
          }
        })
        this.selectedKeys3 = { ...selectedKeys, ...selectedata }
        this.selectedAssetClass = this.selectedKeys3
        this.checked = false
      }
    },

    selectAllAssetClass(event) {
      const selectedata = []
      this.selectedKeys3 = undefined
      const assets = this.assetClassData
      let checked = false
      if (
        this.selectedAssetClass &&
        !_.isEmpty(this.selectedAssetClass) &&
        Object.keys(this.selectedAssetClass).length > 0
      ) {
        checked = Object.keys(this.selectedAssetClass).some(
          i => this.selectedAssetClass[i].partialChecked,
        )
      }
      if (this.selectedAssetClassId && this.checked && !checked) {
        assets.map(data => {
          let checked = false
          let partiallyChecked = false
          if (data.children) {
            data.children.map(i => {
              if (i.children) {
                i.children.map(x => {
                  if (
                    this.activeTab === '1' &&
                    x.data.assetClassId === this.selectedAssetClassId
                  ) {
                    selectedata[x.key] = {
                      checked: true,
                      partialChecked: false,
                    }
                  } else if (
                    this.activeTab === '2' &&
                    x.data.method === this.selectedAssetClassId
                  ) {
                    selectedata[x.key] = {
                      checked: true,
                      partialChecked: false,
                    }
                  } else if (
                    this.activeTab === '3' &&
                    x.data.convention === this.selectedAssetClassId
                  ) {
                    selectedata[x.key] = {
                      checked: true,
                      partialChecked: false,
                    }
                  } else {
                    this.checked = false
                    if (this.activeTab === '1') {
                      partiallyChecked = i.children.some(
                        i => i.data.assetClassId === this.selectedAssetClassId,
                      )
                    } else if (this.activeTab === '2') {
                      partiallyChecked = i.children.some(
                        i => i.data.method === this.selectedAssetClassId,
                      )
                    } else if (this.activeTab === '3') {
                      partiallyChecked = i.children.some(
                        i => i.data.convention === this.selectedAssetClassId,
                      )
                    }
                  }
                })
                if (this.activeTab === '1') {
                  checked = i.children.every(
                    i => i.data.assetClassId === this.selectedAssetClassId,
                  )
                } else if (this.activeTab === '2') {
                  checked = i.children.every(
                    i => i.data.method === this.selectedAssetClassId,
                  )
                } else if (this.activeTab === '3') {
                  checked = i.children.every(
                    i => i.data.convention === this.selectedAssetClassId,
                  )
                }
                selectedata[i.key] = {
                  checked: checked,
                  partialChecked: partiallyChecked,
                }
              }
            })
            selectedata[data.key] = {
              checked: checked,
              partialChecked: partiallyChecked,
            }
          }
        })
        this.selectedKeys3 = selectedata
      } else if (this.checked && !checked) {
        assets.map(data => {
          selectedata[data.key] = { checked: true, partialChecked: false }
          if (data.children) {
            data.children.map(firstLevel => {
              selectedata[firstLevel.key] = {
                checked: true,
                partialChecked: false,
              }
              if (firstLevel.children) {
                firstLevel.children.map(secondLevel => {
                  selectedata[secondLevel.key] = {
                    checked: true,
                    partialChecked: false,
                  }
                })
              }
            })
            this.selectedKeys3 = selectedata
          }
        })
      } else if (checked) {
        this.selectedKeys3 = undefined
        this.checked = false
      } else {
        this.selectedKeys3 = undefined
        this.checked = false
      }
      this.selectedAssetClass = this.selectedKeys3
    },

    applyDepreciation(type) {
      let isValid = false
      let url = null
      const list = []
      if (
        this.selectedKeys3 &&
        !_.isEmpty(this.selectedKeys3) &&
        Object.keys(this.selectedKeys3).length > 0
      ) {
        Object.keys(this.selectedKeys3).forEach(key => {
          const splitKey = key.split('-')
          if (splitKey && splitKey.length > 1) {
            if (this.selectedKeys3[key].checked) {
              isValid = true
              list.push({
                categoryCodeId: splitKey[2],
                assetId: splitKey[0],
              })
            }
          }
        })
      }
      if (isValid) {
        this.loaderBonus = true
        this.closable = false
        const request = {
          assets: list,
        }
        switch (type) {
          case 'Asset Class':
            Object.assign(request, {
              assetClassId: this.selectSource.assetClassId,
              gdsAds: this.ADSGDS,
            })

            url = projectAPIs.project.asset.report.assetClass(
              this.$route.params.id,
            )
            break

          case 'Method':
            Object.assign(request, {
              method: this.toMethod,
            })

            url = projectAPIs.project.asset.report.method(
              this.$route.params.id,
            )
            break

          default:
            Object.assign(request, {
              convention: this.toConvention,
            })

            url = projectAPIs.project.asset.report.convention(
              this.$route.params.id,
            )
            break
        }

        instance
          .patch(url, request)
          .then(res => {
            this.isAssetClassChanged = false
            this.$root.$emit('changeAssetClass', true)
          })
          .catch(err => {
            this.loaderBonus = false
            this.closable = true
            errorService(err)
          })
      } else {
        let msg
        let description
        switch (type) {
          case 'Asset Class':
            msg =
              'Please select at least one asset class to convert into another asset class'
            description = 'Change Asset Class'
            break

          case 'Method':
            msg =
              'Please select at least one method to convert into another method'
            description = 'Change Method'
            break

          default:
            msg =
              'Please select at least one convention to convert into another convention'
            description = 'Change Convention'
            break
        }
        showNotification('warning', description, msg)
      }
    },

    messageReceived: function(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.fileDownloaded) {
        this.datafromSocket = data.Result
        this.downloadData(data.Result)
        if (!data.Result.isPreview) {
          Object.assign(this.datafromSocket, { name: 'Report' })
          Object.assign(data, {
            name: data.Result.downloadName,
            extension: data.Result.filename.split('.')[1],
          })
          this.$root.$emit('socketMessage', data)
        }
      } else if (this.events.includes(data.EventType)) {
        this.$notification.destroy()
        this.loaderBonus = false
        this.closable = true
        if (data.Status === 'SUCCESS') {
          this.fromAssetClass = undefined
          this.toAssetClass = undefined
          this.fromMethod = undefined
          this.toMethod = undefined
          this.fromConvention = undefined
          this.toConvention = undefined
          this.getDepreciationDropdwons()
          this.getBonus()
          this.getAssetClass()
          this.selectSource = undefined
          this.ADSGDS = undefined
          this.selectedKeys3 = undefined
          this.selectedAssetClassId = undefined
          this.selectedAssetClass = null
          if (this.previewReport && !this.visibleAssetClass) {
            this.preview()
          }
        } else {
          showNotification('error', 'Socket', data.Result.Message)
        }
      } else if (data.EventType === socketEvents.generateReport) {
        if (data.Status === 'ERROR') {
          this.loadReports = false
          showNotification('error', 'Socket', data.Result.Message)
        }
      }
    },

    getTakeOffValidation() {
      instance
        .get(
          projectAPIs.project.asset.report.validateTakeoff(
            this.$route.params.id,
          ),
        )
        .then(res => {
          this.takeoff = _.get(res.data, 'result', {})
        })
        .catch(err => {
          errorService(err)
        })
    },

    reconcileReport() {
      instance
        .post(
          projectAPIs.project.asset.report.reconcileReport(
            this.$route.params.id,
          ),
        )
        .then(res => {
          this.$root.$emit('popupUpdation', false, true, null)
        })
        .catch(err => {
          this.$root.$emit('popupUpdation', false, true, null)
          errorService(err)
        })
    },

    onTabChange(key) {
      this.activeTab = key
      this.selectedKeys3 = undefined
      this.fromAssetClass = undefined
      this.toAssetClass = undefined
      this.fromMethod = undefined
      this.toMethod = undefined
      this.fromConvention = undefined
      this.toConvention = undefined
      this.selectedAssetClass = undefined
      this.selectedAssetClassId = undefined
      this.checked = false
    },

    onChangeConvention(val) {
      this.checked = false
      this.selectedKeys3 = undefined
      this.selectedAssetClass = undefined
      this.selectedAssetClassId = undefined
      const convention = this.conventions.find(data => data.convention === val)
      this.checked = false
      this.selectedKeys3 = undefined
      this.selectedAssetClass = undefined
      if (convention) {
        this.selectedAssetClassId = convention.convention
      } else {
        this.selectedAssetClassId = undefined
      }
    },

    onChangeMethod(val) {
      this.checked = false
      this.selectedKeys3 = undefined
      this.selectedAssetClass = undefined
      this.selectedAssetClassId = undefined
      const method = this.methods.find(data => data.method === val)
      this.checked = false
      this.selectedKeys3 = undefined
      this.selectedAssetClass = undefined
      if (method) {
        this.selectedAssetClassId = method.method
      } else {
        this.selectedAssetClassId = undefined
      }
    },

    getDepreciationDropdwons() {
      this.loader = true
      Promise.all([
        this.getAssetClasses(),
        this.getConvetions(),
        this.getMethods(),
      ])
        .then(
          axios.spread((...responses) => {
            this.loader = false
            this.assetClassList = _.get(responses[0].data, 'result', [])
            this.conventions = _.get(responses[1].data, 'result', [])
            this.methods = _.get(responses[2].data, 'result', [])
          }),
        )
        .catch(err => {
          this.$root.$emit('popupUpdation', false, true, null)
          errorService(err)
        })
    },

    getAssetClasses() {
      return instance.get(
        projectAPIs.project.asset.report.assetClasslist(this.$route.params.id),
      )
    },

    getConvetions() {
      return instance.get(
        projectAPIs.project.asset.report.conventions(this.$route.params.id),
      )
    },

    getMethods() {
      return instance.get(
        projectAPIs.project.asset.report.methods(this.$route.params.id),
      )
    },
  },
}
